// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__uNCym","primary":"Button_primary__25ud-","secondary":"Button_secondary__Hrz9d","noText":"Button_noText__vOLP1","noIcon":"Button_noIcon__kr6Bm"};